<template>
    <div id="imageSaverBody" @click="hideTaskPopup">
        <div id="imageSaverBox">
            <div id="imageSaverContent">
                <!-- 标签 -->
                <el-tabs v-model="activeTab" ref="imageSaverTab">
                    <!-- Instagram -->
                    <el-tab-pane :label="$t('language.imageSaver.tabTitleIns')" name="instagram">
                        <div class="imagesaver_desc">{{ $t('language.imageSaver.insLinkTip') }}</div>
                        <div class="imagesaver_input_button">
                            <el-input ref="insInputEle" class="imagesaver_input" type="textarea" autosize resize="none" :placeholder="insInputFocus?'':insInputText"
                                v-model="insUrls" @input="limitRowsInsUrls" spellcheck="false" @focus="insInputFocus=true" @blur="insInputFocus=false"></el-input>
                            <el-button type="primary" :disabled="insUrls == ''" @click="decodeInstagram"
                                :loading="insEncodeing">{{ $t('language.imageSaver.fetchBtn') }}</el-button>
                        </div>
                        <imageSaverPath v-show="node" :node="node" :updateTaskDestDrive="updateTaskDestDrive" :loadDestNode="loadDestNode">
                        </imageSaverPath>
                        <imageSaverView ref="insViews" v-for="(item, index) of insDatas" :key="item.uuid" :item="item"
                            :isPreview="true" :index="index" :addInstagramItems="addInstagramItems" :node="node" :itemsLength="insDatas.length" :inputHeight="insInputHeight" :allTaskLength="tasks.length" :showNewHand="showNewHand"
                            :addTasksToList="addTasksToList" :updateTaskDestDrive="updateTaskDestDrive" :viewImgWigth="viewImgWigth" :lineCount="lineCount" :noImageHeight="noImageHeight">
                        </imageSaverView>
                    </el-tab-pane>
                    <!-- Web -->
                    <el-tab-pane :label="$t('language.imageSaver.tabTitleWeb')" name="web">
                        <div class="imagesaver_desc">{{ $t('language.imageSaver.inputTipWeb') }}</div>
                        <div class="imagesaver_input_button">
                            <el-input ref="webInputEle" class="imagesaver_input" type="textarea" autosize resize="none"
                                :placeholder="webInputFocus?'':webInputText"
                                v-model="webUrls" @input="limitRowsWebUrls" spellcheck="false" @focus="webInputFocus=true" @blur="webInputFocus=false"></el-input>
                            <el-button type="primary" :disabled="webUrls == ''" @click="decodeWebUrl"
                                :loading="webEncodeing">{{ $t('language.imageSaver.fetchBtn') }}</el-button>
                        </div>
                        <imageSaverPath v-show="node" :node="node" :updateTaskDestDrive="updateTaskDestDrive" :loadDestNode="loadDestNode">
                        </imageSaverPath>
                        <imageSaverView ref="webViews" v-for="(item, index) of webDatas" :key="item.uuid" :item="item" :isPreview="false" :index="index" :itemsLength="webDatas.length" :inputHeight="webInputHeight" :allTaskLength="tasks.length" :showNewHand="showNewHand"
                            :node="node" :addTasksToList="addTasksToList" :updateTaskDestDrive="updateTaskDestDrive" :viewImgWigth="viewImgWigth" :lineCount="lineCount" :noImageHeight="noImageHeight"></imageSaverView>
                    </el-tab-pane>
                    <!-- Google -->
                    <el-tab-pane :label="$t('language.imageSaver.tabTitleGoogle')" name="google">
                        <div class="imagesaver_desc">{{ $t('language.imageSaver.inputTipGoogle') }}</div>
                        <div class="imagesaver_input_button">
                            <el-input ref="googleInputEle" class="imagesaver_input" type="textarea" autosize resize="none" :placeholder="googleInputFocus?'':googleInputText"
                                v-model="googleKeywords" @input="limitRowsKeywords" spellcheck="false" @focus="googleInputFocus=true" @blur="googleInputFocus=false"></el-input>
                            <el-button type="primary" :disabled="googleKeywords == ''" @click="decodeGoogleSearch"
                                :loading="googleEncodeing">{{ $t('language.imageSaver.fetchBtn') }}</el-button>
                        </div>
                        <imageSaverPath v-show="node" :node="node" :updateTaskDestDrive="updateTaskDestDrive" :loadDestNode="loadDestNode">
                        </imageSaverPath>
                        <imageSaverView ref="googleViews" v-for="(item, index) of googleDatas" :key="item.uuid" :item="item" :isPreview="false" :index="index" :itemsLength="googleDatas.length" :inputHeight="googleInputHeight" :allTaskLength="tasks.length" :showNewHand="showNewHand"
                            :node="node" :addTasksToList="addTasksToList" :updateTaskDestDrive="updateTaskDestDrive" :viewImgWigth="viewImgWigth" :lineCount="lineCount" :noImageHeight="noImageHeight"></imageSaverView>
                    </el-tab-pane>
                </el-tabs>
                <!-- 任务图标 -->
                <el-badge id="taskImageSaver" :value="unfinishTaskCount" :max="99" :hidden="unfinishTaskCount==0">
                    <div @click.stop="showTaskPopup"></div>
                </el-badge>
                <!-- 覆盖div -->
                <div id="coverDiv"></div>
                <!-- 任务弹窗 -->
                <div id="taskImageSaverBox" v-show="showTaskBox">
                    <imageSaverTask :tasks="tasks" :retryTask="retryTask" :cancelTask="cancelTask"
                        :clearTask="clearTask"></imageSaverTask>
                </div>
            </div>
        </div>
        <!-- 底部波浪背景 -->
        <div class="task-buttom"></div>
        <!-- 任务列表新手引导 -->
        <div id="taskTipBox" v-if="isShowNewHand">
            <!-- 提示框 -->
            <div id="taskTip">
                <!-- 关闭 -->
                <div id="taskTipClose" @click="isShowNewHand=false"></div>
                <!-- 文字 -->
                <div id="taskTipText">{{ $t('language.imageSaver.newHandText') }}</div>
                <!-- 按钮 -->
                <el-button id="taskTipBtn" type="primary" @click="isShowNewHand=false">{{ $t('language.imageSaver.newHandBtn') }}</el-button>
                <!-- 箭头 -->
                <div id="rightArrowhead"></div>
            </div>
            <!-- 圆圈 -->
            <div id="taskTipIconBox">
                <!-- 数字 -->
                <el-badge id="taskTipIcon" :value="unfinishTaskCount" :max="99" :hidden="unfinishTaskCount==0">
                    <!-- 图标 -->
                    <div></div>
                </el-badge>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import imageSaverView from "@/components/workspace/image_saver_view";
import imageSaverPath from "@/components/workspace/image_saver_path";
import imageSaverTask from "@/components/workspace/image_saver_task";
import taskListUtils from "@/js/workspace/task_list_util.js";
import commonUtils from "@/js/workspace/common_util.js";

export default {
    name: "imageSaver",
    components: {
        imageSaverView,
        imageSaverPath,
        imageSaverTask,
    },
    computed: {
        // 未完成的任务计数
        unfinishTaskCount() {
            var count = 0;
            for (var i = 0; i < this.tasks.length; i++) {
                var status = this.tasks[i].status;
                if (status == 'create' || status == 'run') {
                    count++;
                }
            }
            return count;
        }
    },
    data() {
        return {
            // 目的地云盘节点
            node: null,
            // 默认Tab页
            activeTab: "instagram",
            // 是否显示任务弹窗
            showTaskBox: false,
            // WebUrl
            webUrls: "",
            webUrlsLast: "",
            webInputHeight: 0,
            webInputFocus: false,
            webInputText: this.$t('language.imageSaver.inputTipHttp'),
            webEncodeing: false,
            webDatas: [],
            // Instagram
            insUrls: "",
            insUrlsLast: "",
            insInputHeight: 0,
            insInputFocus: false,
            insInputText: this.$t('language.imageSaver.inputTipIns'),
            insEncodeing: false,
            insDatas: [],
            // Google
            googleKeywords: "",
            googleKeywordsLast: "",
            googleInputHeight: 0,
            googleInputFocus: false,
            googleInputText: this.$t('language.imageSaver.inputTipGoogleBlank'),
            googleEncodeing: false,
            googleDatas: [],
            // 加载预览图
            isLoadPreviewImage: false,
            isLoadPreviewImageIng: false,
            // 任务（最近任务）
            tasks: [],
            // 是否正在加载进度
            isLoadProg: false,
            // 是否正在加载任务：保证这次加载完成后再进行下次加载
            isLoadingTask: false,
            // 加载任务标记：保证这次加载过程没有做其他影响结果的事
            loadingTaskFlag: 0,
            // 总任务数
            allTaskCount: 0,
            // 剩余未执行的任务数
            remainTaskCount: 0,
            // 前后端任务是否同步（0：已同步，大于0：N次未同步）
            taskSyncFlag: 0,
            // 预览图宽
            viewImgWigth: 0,
            // 一行放几个
            lineCount: 0,
            // 没有图片的外框高
            noImageHeight: 0,
            // 是否显示新手引导
            isShowNewHand: false,
        };
    },
    mounted() {
        // 修复刷新页面Tab下面没有下划线
        this.checkTabSelect = setInterval(() => {
            var tabs = this.$refs.imageSaverTab.$children[0].$refs.tabs;
            if (tabs) {
                var width = tabs[0].clientWidth - 20;
                if (width > 0) {
                    this.$refs.imageSaverTab.$children[0].$children[0].$el.style.width = width + 'px';
                    clearInterval(this.checkTabSelect);
                }
            }
        }, 100);
        // 初始化窗口大小变化
        this.updateWindowSize();
        // 监听窗口大小变化
        window.addEventListener('resize', this.updateWindowSize);
        // 获取任务目的地云盘
        this.loadDestNode();
        /*
        // 列出最近任务
        this.listRecentlyTask(true);
        // 列出最近任务（之前是通过列出所有任务+列出所有进度实现，现在使用多次列出最近任务实现）
        this.loadImageSaverRecentlyTask = setInterval(() => {
            if (this.$route.name != 'imageSaver') {
                return;
            } else {
                this.listRecentlyTask();
            }
        }, 5000);
        */
        // 列出任务
        this.listTask();
        // 获取任务进度（暂时注释掉：获取所有任务和获取所有进度的代码）
        this.loadImageSaverTasksProg = setInterval(() => {
            if (this.$route.name != 'imageSaver') return;
            if (this.unfinishTaskCount > 0) {
                // 正在加载进度，这次不加载
                if (this.isLoadProg) return;
                // 同时加载任务预览图会出问题，把tempTask定义到这里，且是对象就没有问题
                var tempTask = {};
                this.isLoadProg = true;
                taskListUtils.imageSaverRequest("/prog", {}, res => {
                    if (res.code == 200) {
                        var tempData = res.data;
                        var size = tempData.size;
                        var data = tempData.prog;
                        // 刷新流量
                        if (this.unfinishTaskCount != tempData.remain) {
                            commonUtils.refreshUserInfo(this, function(res) {});
                        }
                        // 已经不存在的任务
                        var notExistTask = [];
                        // 更新状态和进度
                        for (var i = 0; i < this.tasks.length; i++) {
                            // 检测不存在的任务
                            if (!data[this.tasks[i].id]) {
                                notExistTask.push(this.tasks[i].id);
                                continue;
                            }
                            // 视情况，更新预览图
                            // 上次的状态是run或create
                            if (this.tasks[i].status == 'run' || this.tasks[i].status == 'create') {
                                // 这次的状态是success
                                if (data[this.tasks[i].id].status == 'success') {
                                    // 是instagram类型的资源
                                    if (this.tasks[i].fromType == 'instagram') {
                                        // 上次没有预览图
                                        if (this.tasks[i].fromData.pre == '#') {
                                            // 准备加载任务预览图
                                            tempTask[this.tasks[i].id] = this.tasks[i];
                                            taskListUtils.imageSaverRequest("/loadFromData", {id:this.tasks[i].id}, res => {
                                                if (res.code == 200) {
                                                    Vue.set(tempTask[res.data.id], 'fromData', res.data.bean);
                                                }
                                            });
                                        }
                                    }
                                }
                            }
                            // 更新状态和进度
                            this.tasks[i].status = data[this.tasks[i].id].status;
                            this.tasks[i].msg = data[this.tasks[i].id].msg;
                        }
                        // 如果任务数量对不上，说明任务有新增，则刷新任务
                        // 或者说有任务被删除
                        if (size != this.tasks.length || notExistTask.length > 0) {
                            this.taskSyncFlag = this.taskSyncFlag + 1;
                            // 6次未同步，每次的间隔是5秒，也就是30秒未同步就刷新
                            // 或者说有任务被删除
                            if (this.taskSyncFlag >= 6 || notExistTask.length > 0) {
                                this.taskSyncFlag = 0;
                                this.listTask();
                            }
                        } else {
                            this.taskSyncFlag = 0;
                        }
                    } else if (res.message == 'saltInvalid') {
                        // 账号被挤下去了
                        commonUtils.logoutAndJumpToSign();
                    }
                    // 标记已完成进度加载
                    this.isLoadProg = false;
                });
            } else {
                // 没有任务的情况下也会每个30秒刷新一次任务
                this.taskSyncFlag = this.taskSyncFlag + 1;
                if (this.taskSyncFlag >= 6) {
                    this.taskSyncFlag = 0;
                    this.listTask();
                }
            }
        }, 5000);
        // 加载预览图
        this.loadPreviewImage = setInterval(() => {
            if (this.$route.name != 'imageSaver') return;
            // 如果启动了加载预览图
            if (this.isLoadPreviewImage) {
                // 如果当前并没有正在加载的
                if (!this.isLoadPreviewImageIng) {
                    // 标记为正在加载
                    this.isLoadPreviewImageIng = true;
                    // 等下要加载对象
                    var loadBeans = [];
                    // 解析出要加载对象
                    for (var i = 0; i < this.insDatas.length; i++) {
                        var list = this.insDatas[i].list;
                        for (var j = 0; j < list.length; j++) {
                            var bean = list[j];
                            if (!bean.loaded && !bean.preview) {
                                // 第一个没有预览过的对象
                                bean.uuid = this.generateUUID();
                                loadBeans.push(bean);
                                // 继续处理后续N个没有预览过的对象
                                const n = 2;
                                for (var x=1; x<=n; x++) {
                                    if (j+x < list.length) {
                                        var tempBean = list[j+x];
                                        if (!tempBean.loaded && !tempBean.preview) {
                                            // 设置UUID的目的是请求响应回来时需要与请求前的数据匹配
                                            tempBean.uuid = this.generateUUID();
                                            loadBeans.push(tempBean);
                                        }
                                    }
                                }
                                // 每个视图只匹配N+1个
                                break;
                            }
                        }
                    }
                    // 如何处理
                    if (loadBeans.length > 0) {
                        // 开始加载预览图
                        taskListUtils.imageSaverRequest("/previews", {list: loadBeans}, res => {
                            if (res.code == 200) {
                                // 预览成功
                                var arr = res.data;
                                for (var i=0; i<arr.length; i++) {
                                    // 准备根据UUID匹配数据
                                    var uuid = arr[i].uuid;
                                    // 反正不在需要，就删除UUID
                                    delete arr[i].uuid;
                                    // 开始匹配
                                    for (var j=0; j<loadBeans.length; j++) {
                                        // 匹配成功
                                        if (loadBeans[j].uuid == uuid) {
                                            // 反正不在需要，就删除UUID
                                            delete loadBeans[j].uuid;
                                            // 更新数据
                                            Vue.set(loadBeans[j], 'preview', arr[i]);
                                            Vue.set(loadBeans[j], 'status', 'success');
                                            // 本轮匹配完成，继续下一轮匹配
                                            break;
                                        }
                                    }
                                }
                            } else {
                                // 预览失败
                                // this.errorTips("Loading preview failed.");
                            }
                            // 标记刚刚请求这些已经加载过
                            for (var i=0; i<loadBeans.length; i++) {
                                loadBeans[i].loaded = true;
                            }
                            // 标记本次请求完毕
                            this.isLoadPreviewImageIng = false;
                        });
                    } else {
                        // 所有预览图都已加载完，停止解析
                        this.isLoadPreviewImage = false;
                        this.isLoadPreviewImageIng = false;
                    }
                }
            }
        }, 200);
    },
    beforeDestroy() {
        // 清理定时器
        clearInterval(this.loadPreviewImage);
        /*
        clearInterval(this.loadImageSaverRecentlyTask);
        */
        clearInterval(this.loadImageSaverTasksProg);
        // 移除窗口大小变化的监听
        window.removeEventListener('resize', this.updateWindowSize);
    },
    methods: {
        // 显示新手引导
        showNewHand() {
            this.isShowNewHand = true;
        },
        // 字符串Base64编码
        toBase64(str) {
            // 创建一个 TextEncoder 实例
            const encoder = new TextEncoder();
            // 将字符串转换为一个 Uint8Array
            const byteArray = encoder.encode(str);
            // 转Base64
            let binary = '';
            const len = byteArray.byteLength;
            for (let i = 0; i < len; i++) {
                binary += String.fromCharCode(byteArray[i]);
            }
            return btoa(binary);
        },
        // 生成UUID
        generateUUID() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        // 错误提示
        errorTips(msg) {
            this.$toast({
                text: msg,
                type: 'fail',
                idValue: "allBox"
            });
        },
        // 更新窗口大小
        updateWindowSize() {
            {
                // 计算没有图片外框高度
                this.noImageHeight = window.innerHeight - 380;
                // 没有目的地节点占位的情况下还可以再高点
                if (!this.node) this.noImageHeight += 100;
            }
            {
                // 计算预览图最终宽度
                // 357是外面所有宽，20是里面左边距，4是容错
                var boxWigth = window.innerWidth - 357 - 20 - 4;
                // 最小宽，200是需求规定，20是外边距
                var minWidth = 200 + 20;
                // 最大宽，340是需求规定，20是外边距
                var maxWidth = 340 + 20;
                // 一行放几个
                var lineCount = Math.floor((boxWigth/minWidth+boxWigth/maxWidth)/2);
                // 每个的宽度，20是外边距
                this.viewImgWigth = Math.floor(boxWigth / lineCount) - 20;
                // 赋值一行放几个
                this.lineCount = lineCount;
            }
        },
        // 加载目的地节点
        loadDestNode() {
            taskListUtils.imageSaverRequest("/loadTaskDestDrive", {}, res => {
                if (res.code == 200) {
                    this.node = res.data;
                    this.updateWindowSize();
                } else {
                    this.node = null;
                }
            });
        },
        // 重试任务
        retryTask(index) {
            this.loadingTaskFlag = 0;
            taskListUtils.imageSaverRequest("/retry", { id: this.tasks[index].id }, res => {
                if (res.code == 200) {
                    this.tasks[index].status = 'create';
                    this.tasks[index].msg = '';
                } else {
                    this.errorTips(res.message);
                }
            });
        },
        // 取消任务
        cancelTask(index) {
            taskListUtils.imageSaverRequest("/deleteTask", { id: this.tasks[index].id }, res => {
                if (res.code == 200) {
                    this.tasks.splice(index, 1);
                } else {
                    this.errorTips(res.message);
                }
            });
        },
        // 清理任务
        clearTask() {
            if (this.tasks.length != 0) {
                taskListUtils.imageSaverRequest("/clearDone", {}, res => {
                    if (res.code == 200) {
                        /*
                        this.listRecentlyTask(true);
                        */
                        this.listTask();
                    } else {
                        this.errorTips(res.message);
                    }
                });
            }
        },
        // 列出任务
        listTask() {
            taskListUtils.imageSaverRequest("/list", {}, res => {
                if (res.code == 200) {
                    this.tasks = res.data;
                } else {
                    this.errorTips(res.message);
                }
            });
        },
        // 列出最近任务
        /*
        listRecentlyTask(force) {
            if (!this.isLoadingTask) {
                // 所有任务都执行完，不再继续列出任务
                if (this.remainTaskCount>0 || force) {
                    // 开始加载任务
                    this.isLoadingTask = true;
                    var now = new Date().getTime();
                    this.loadingTaskFlag = now;
                    taskListUtils.imageSaverRequest("/listRecently", {}, res => {
                        // 如果加载任务结束时，之前设定的标记没有变化，才处理这次的结果
                        if (this.loadingTaskFlag == now) {
                            if (res.code == 200) {
                                // 刷新流量
                                if (this.remainTaskCount != res.data.remain) {
                                    commonUtils.refreshUserInfo(this, function(res) {});
                                }
                                // 更新任务列表相关信息
                                this.tasks = res.data.list;
                                this.allTaskCount = res.data.size;
                                this.remainTaskCount = res.data.remain;
                            } else if (res.message == 'saltInvalid') {
                                commonUtils.logoutAndJumpToSign();
                            }
                        }
                        // 结束加载任务
                        this.isLoadingTask = false;
                    });
                }
            }
        },
        */
        // 刚刚创建成功的任务添加到列表
        addTasksToList(items) {
            if (items.length == 1) {
                this.tasks.unshift(items[0]);
            } else {
                // 不会有这种情况
                this.tasks = this.tasks.concat(items);
            }
        },
        // 增加更多
        addInstagramItems(index, data) {
            this.insDatas[index].next = data.next;
            this.insDatas[index].list = this.insDatas[index].list.concat(data.list);
            this.isLoadPreviewImage = true;
        },
        // 更新任务目的地云盘
        updateTaskDestDrive(node) {
            // 准备节点信息
            var tempNode = {};
            // 获取文件夹ID
            if (node.pnode) {
                tempNode.folder = node.id;
            } else {
                tempNode.folder = node.rootId;
            }
            // 获取云盘信息
            var path = [];
            var temp = node;
            while (temp.pnode) {
                path.push({id:temp.id,name:temp.name});
                temp = temp.pnode;
            }
            path.push({id:temp.rootId,name:temp.name});
            tempNode.path = JSON.stringify(path);
            tempNode.id = temp.id;
            tempNode.type = temp.driveType;
            // 更新节点参数准备
            var data = {};
            data.id = tempNode.id;
            data.dt = tempNode.type;
            data.n = this.toBase64(tempNode.path);
            data.pt = tempNode.folder;
            // 更新节点请求
            taskListUtils.imageSaverRequest("/updateTaskDestDrive", data, res => {
                if (res.code == 200) {
                    // 更新成功
                    this.node = tempNode;
                } else {
                    // 更新失败
                    this.node = null;
                    this.errorTips(res.message);
                }
            });
        },
        // 只能输入3行webUrls
        limitRowsWebUrls() {
            if (this.webUrls.split('\n').length > 3) {
                this.webUrls = this.webUrlsLast;
            } else {
                this.webUrlsLast = this.webUrls;
            }
            setTimeout(() => {
                this.webInputHeight = this.$refs.webInputEle.$el.offsetHeight;
            }, 0);
        },
        // 只能输入3行insUrls
        limitRowsInsUrls() {
            if (this.insUrls.split('\n').length > 3) {
                this.insUrls = this.insUrlsLast;
            } else {
                this.insUrlsLast = this.insUrls;
            }
            setTimeout(() => {
                this.insInputHeight = this.$refs.insInputEle.$el.offsetHeight;
            }, 0);
        },
        // 只能输入1行关键字
        limitRowsKeywords() {
            if (this.googleKeywords.split('\n').length > 1) {
                this.googleKeywords = this.googleKeywordsLast;
            } else {
                this.googleKeywordsLast = this.googleKeywords;
            }
            setTimeout(() => {
                this.googleInputHeight = this.$refs.googleInputEle.$el.offsetHeight;
            }, 0);
        },
        // 解析一般网址
        decodeWebUrl() {
            this.webDatas = [];
            this.webEncodeing = true;
            taskListUtils.imageSaverRequest("/decodeWebUrl", { urls: this.webUrls.split('\n') }, res => {
                this.webEncodeing = false;
                if (res.code == 200) {
                    this.webDatas = res.data;
                    // 滚动到第一个视图
                    this.$nextTick(function () {
                        const firstView = this.$refs.webViews[0];
                        firstView.$el.scrollIntoView({ behavior: 'smooth' });
                    });
                } else {
                    this.errorTips(res.message);
                }
            });
        },
        // 解析Instagram
        decodeInstagram() {
            this.insDatas = [];
            this.insEncodeing = true;
            var starts = [];
            var urls = this.insUrls.split('\n');
            for (var i = 0; i < urls.length; i++) {
                starts[i] = '';
            }
            taskListUtils.imageSaverRequest("/decodeInstagram", { urls: urls, starts: starts }, res => {
                this.insEncodeing = false;
                if (res.code == 200) {
                    this.insDatas = res.data;
                    this.isLoadPreviewImage = true;
                    // 滚动到第一个视图
                    this.$nextTick(function () {
                        const firstView = this.$refs.insViews[0];
                        firstView.$el.scrollIntoView({ behavior: 'smooth' });
                    });
                } else {
                    this.errorTips(res.message);
                }
            });
        },
        // 解析谷歌图片搜索
        decodeGoogleSearch() {
            this.googleDatas = [];
            this.googleEncodeing = true;
            taskListUtils.imageSaverRequest("/decodeGoogleSearch", { keywords: this.googleKeywords.split('\n') }, res => {
                this.googleEncodeing = false;
                if (res.code == 200) {
                    this.googleDatas = res.data;
                    // 滚动到第一个视图
                    this.$nextTick(function () {
                        const firstView = this.$refs.googleViews[0];
                        firstView.$el.scrollIntoView({ behavior: 'smooth' });
                    });
                } else {
                    this.errorTips(res.message);
                }
            });
        },
        // 显示任务列表
        showTaskPopup() {
            this.showTaskBox = true;
        },
        // 隐藏任务列表
        hideTaskPopup() {
            this.showTaskBox = false;
        },
    }
};
</script>

<style>
/* 整个图片保存 */
#imageSaverBody {
    top: 60px;
    height: calc(100% - 60px);
    color: black;
    position: relative;
    background-color: #F2F7FE;
    font-family: Arial, "Microsoft YaHei", 微软雅黑;
}

/* 控制主要内容 */
#imageSaverBox {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    position: absolute;
    z-index: 2;
    left: 0;
    top: 0;
}

/* 主要内容 */
#imageSaverContent {
    height: 100%;
    position: relative;
}

/* 底部波浪背景 */
#imageSaverBody .task-buttom {
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
}

/* 标签 */
#imageSaverContent>.el-tabs {
    padding: 50px;
    padding-right: 0px;
    height: 100%;
    box-sizing: border-box;
}

/* Tab标题 */
#imageSaverContent .el-tabs__item {
    font-weight: bolder;
    font-size: 18px;
}

#imageSaverContent .el-tabs__content {
    overflow: auto;
}

/* 标签体内容 */
#imageSaverBody .el-tabs__content {
    height: calc(100% - 30px);
    margin-top: 30px;
    margin-right: 2px;
    padding-right: 48px;
}

/* 滚动条 */
#imageSaverBody .el-tabs__content::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: transparent;
}

#imageSaverBody .el-tabs__content::-webkit-scrollbar-thumb {
    width: 4px;
    height: 4px;
    border-radius: 4px;
    background: #BECAE4;
    min-height: 100px;
}

/* Web描述 */
.imagesaver_desc {
    margin-bottom: 10px;
    font-size: 18px;
}

/* Web网址和按钮 */
.imagesaver_input_button {
    padding-bottom: 20px;
    display: flex;
    gap: 20px;
}

/* 输入框样式 */
.imagesaver_input>textarea {
    max-height: 93px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

/* Web网址 */
.imagesaver_input_button textarea {
    font-family: Arial, "Microsoft YaHei", 微软雅黑;
    padding: 14px 20px;
    font-size: 14px;
}

/* Web按钮 */
.imagesaver_input_button>.el-button {
    width: 220px;
    height: 50px;
    font-size: 16px;
    border-color: #5562B4;
    background-color: #5562B4;
}

.imagesaver_input_button>.el-button--primary:focus {
    border-color: #5562B4;
    background-color: #5562B4;
}

.imagesaver_input_button>.el-button--primary:hover {
    border-color: #3250C9;
    background-color: #3250C9;
}

.imagesaver_input_button>.el-button--primary:active {
    border-color: #1836B0;
    background-color: #1836B0;
}

/* 禁用状态 */
.imagesaver_input_button>.el-button.is-disabled {
    border-color: #848fd1;
    background-color: #848fd1;
}

.imagesaver_input_button>.el-button.is-disabled:hover {
    border-color: #848fd1;
    background-color: #848fd1;
}

/* 正在加载文字颜色 */
.imagesaver_input_button>.el-button.is-loading {
    color: #a1addf;
}

/* 正在加载状态 */
.imagesaver_input_button>.el-button.is-loading:before {
    background-color: rgba(255, 255, 255, 0.1);
}

/* 替换加载中图标位置 */
.imagesaver_input_button .el-icon-loading {
    margin-right: 7px;
    vertical-align: middle;
    position: relative;
    bottom: 2px;
}

/* 替换加载中图标 */
.imagesaver_input_button .el-icon-loading::before {
    content: url('../../assets/images/imageSaver/loading.png');
    display: block;
    height: 20px;
    width: 20px;
}

/* 任务图标定位 */
#taskImageSaver {
    position: absolute;
    right: 60px;
    top: 60px;
}

/* 任务图标 */
#taskImageSaver>div {
    cursor: pointer;
    width: 24px;
    height: 24px;
    background-image: url("../../assets/images/imageSaver/taskImageSaver.svg");
}

/* 任务图标旁边的文字 */
#taskImageSaver>.el-badge__content {
    background: linear-gradient(270deg, #FF7913 0%, #FF4646 102%);
    border-radius: 8px 8px 8px 0px;
    right: 5px;
    top: -3px;
}

/* 覆盖任务图片旁边的横线 */
#coverDiv {
    width: 56px;
    height: 1px;
    background-color: #f2f7fe;
    position: absolute;
    z-index: 1;
    right: 0px;
    top: 94px;
}

/* 任务弹窗 */
#taskImageSaverBox {
    width: 512px;
    height: 690px;
    background: #F2F7FE;
    box-sizing: border-box;
    border: 1px solid #C1CBE3;
    box-shadow: 0px 10px 10px 0px rgba(87, 94, 136, 0.3);
    position: absolute;
    z-index: 4;
    right: 60px;
    top: 86px;
}

/* 任务列表新手引导，整体 */
#taskTipBox {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    z-index: 2;
    left: 0;
    top: 0;
}

/* 新手引导，提示框 */
#taskTip {
    width: 384px;
    padding-bottom: 20px;
    background-color: #FFF;
    position: absolute;
    right: 150px;
    top: 60px;
}

/* 新手引导，关闭 */
#taskTipClose {
    width: 30px;
    height: 30px;
    cursor: pointer;
    background-image: url("../../assets/images/imageSaver/close.svg");
    position: absolute;
    right: 10px;
    top: 10px;
}

#taskTipClose:hover {
    background-image: url("../../assets/images/imageSaver/closeHover.svg");
}

#taskTipClose:active {
    background-image: url("../../assets/images/imageSaver/closeActive.svg");
}


/* 新手引导，文字 */
#taskTipText {
    color: #6F6F6F;
    font-size: 18px;
    padding: 50px 20px 30px 20px;
}

/* 新手引导，按钮 */
#taskTipBtn {
    min-width: 120px;
    margin-right: 20px;
    background: #5562B4;
    border: none;
    padding: 0px 43px !important;
    float: right;
}

#taskTipBtn:hover {
    opacity: 0.9;
}

#taskTipBtn:active {
    opacity: 0.8;
}

/* 新手引导，箭头 */
#rightArrowhead {
    width: 16px;
    height: 32.26px;
    background-image: url("../../assets/images/imageSaver/rightArrowhead.svg");
    position: absolute;
    right: -16px;
    top: 60px;
}

/* 新手引导，圆圈 */
#taskTipIconBox {
    width: 80px;
    height: 80px;
    border-radius: 80px;
    border: 1px solid #5562B4;
    box-sizing: border-box;
    background: #f2f7fe;
    position: absolute;
    right: 32px;
    top: 92px;
}

/* 新手引导，任务图标 */
#taskTipIcon {
    width: 24px;
    height: 24px;
    background-image: url("../../assets/images/imageSaver/taskImageSaver.svg");
    position: absolute;
    margin: auto;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
}

/* 新手引导，任务数 */
#taskTipIcon>.el-badge__content {
    background: linear-gradient(270deg, #FF7913 0%, #FF4646 102%);
    border-radius: 8px 8px 8px 0px;
    right: 5px;
    top: -3px;
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/image_saver.vue